import template from './index.html'
import Base from '../../core/base'
import Grid from '../grid/base'
export default {
  name: 'table',
  init: Base.createViewModel(Grid),
  template: template
}



// WEBPACK FOOTER //
// ./src/components/table/index.js